import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataBlock } from '@fs/zion-ui'

const NoDataAddedMessage = () => {
  const [t] = useTranslation()
  return (
    <div style={{ fontStyle: 'italic' }}>
      <DataBlock inline data={t('view-index.no-data-added', 'None added yet')} heading="" />
    </div>
  )
}

export default NoDataAddedMessage
